import { AppState } from '../AppStateProvider/interfaces';

export const complete = (state: AppState) => {
	console.log('state.preview:', state.preview);
	console.log('state.pairing:', state.pairing);
	console.log('state.brand:', state.brand);
	console.log('state.device:', state.device);
	console.log('state.market:', state.market);
	console.log('state.kvps:', state.kvps);

	// Weg 1: Preview-Setup
	const previewComplete =
		state.preview &&
		state.brand !== null &&
		state?.market?.urls?.delivery !== null &&
		state.device !== null;

	console.log('➤ previewComplete:', previewComplete);

	// Weg 2: Normal-Setup
	const normalComplete =
		state.brand !== null &&
		((state.market?.urls?.delivery !== null && state.kvps !== null) ||
			state.market?.qsUrl !== null) &&
		state.device !== null &&
		state.pairing;

	console.log('➤ normalComplete:', normalComplete);

	const result = previewComplete || normalComplete;

	console.groupEnd();

	return result;
};
